import React, { Component } from 'react';
import { Formik, Field } from 'formik';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { IDriversInsertProps } from '../../types/propTypes';
import { IDriversInsertState } from '../../types/stateTypes';
import DriverService from '../../services/driver/driver-service';
import StandardResponse from '../../models/standard-response';
import { IUserDetail } from '../../models/user';
import { ReactstrapLabel, SelectBox } from '../../components/reactstrap-formik';
import DriverGroupService from '../../services/driverGroup/driverGroup-service';
import { IDriverGroupList } from '../../models/driverGroup';
import { IDriverDetailForm, IDriverDetail, IDriverGroupAccess, IDriverPromotionsAccess } from '../../models/driver';
import CreatableSelectBox from '../../components/reactstrap-formik/CreatableSelectBox';
import { DriverValidationSchema } from '../../validation/driver/driver-validation';
import DriverPromotionService from '../../services/driver-promotion/driverPrmotion-service';
import { IDriverPromotionList } from '../../models/driver-promotion';
import moment from 'moment';
import { Common } from '../../utils/constants';
import images from '../../assets/images/index';
import { regionDateAndTime } from '../../utils';
import { store } from '../../store';

const selectedLang = store.getState().UserData?.language
    ? store.getState().UserData?.language
    : store.getState()?.LanguageInfo?.defaultLanguage;
const supportedLanguages = store.getState().LanguageInfo?.supportedLanguages;
let initialLang = selectedLang;
export class DriversInsert extends Component<IDriversInsertProps, IDriversInsertState> {
    state: IDriversInsertState;

    private intialValues: IDriverDetailForm = {
        first_name: '',
        last_name: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        county: '',
        postal_code: '',
        billing_address: '',
        billing_address2: '',
        billing_city: '',
        billing_county: '',
        billing_postal_code: '',
        referral_code: '',
        payment_type: '',
        account_type: '',
        organization: '',
        driverGroups: [],
        promotion: null,
        currentDriverPromotion: '',
        driverPromotionJoinDate: '',
        languagePreference: '',
    };
    private driverService: DriverService;
    private driverGroupService: DriverGroupService;
    private driverPromotionService: DriverPromotionService;
    constructor(props) {
        super(props);
        this.state = {
            driverTagList: [],
            driverGroupList: [],
            driverPromotionsList: [],
            mode: this.props.id !== null ? 'EDIT' : 'ADD',
            address: null,
            billing_address: null,
        };
        this.driverService = new DriverService();
        this.driverGroupService = new DriverGroupService();
        this.driverPromotionService = new DriverPromotionService();
    }
    async componentDidMount() {
        const driverGroups = await this.getDriverGroupList();
        const driverTags = await this.getDriverTags();
        const driverpromotions = await this.getDriverPromotionList();
        let driverDetails: IDriverDetail;
        const userGroupList = [];
        if (driverGroups) {
            driverGroups.forEach((user_group) => {
                userGroupList.push({
                    value: user_group.id,
                    label: user_group.name,
                });
            });
        }
        const promotionsList = [];
        if (driverpromotions) {
            driverpromotions.forEach((item) => {
                promotionsList.push({
                    value: item.id,
                    label:
                        item.expiry_date !== null &&
                        moment(item.expiry_date).diff(moment(new Date(), 'YYYY-MM-DD'), 'days') < 0
                            ? `${item.name} (${item.code}) ${this.props.t('driver.label.expired')}`
                            : `${item.name} (${item.code})`,
                });
            });
        }
        const driverGroup = [];
        let driverpromotion = null;
        let currentDriverPromotion = '';
        let driverPromotionJoinDate = '';
        if (this.state.mode === 'EDIT') {
            driverDetails = await this.getDriverDetails(this.props.id);
            if (driverDetails) {
                if (driverDetails.driver_group_accesses) {
                    driverDetails.driver_group_accesses.forEach((driver_group_access: IDriverGroupAccess) => {
                        driverGroup.push({
                            value: driver_group_access.driver_group.id,
                            label: driver_group_access.driver_group.name,
                        });
                    });
                }
                if (driverDetails.driver_promotions) {
                    driverDetails.driver_promotions.forEach((driver_promotions: IDriverPromotionsAccess) => {
                        currentDriverPromotion = `${driver_promotions.promotion.name} (${driver_promotions.promotion.code})`;
                        driverPromotionJoinDate =
                            driver_promotions?.created_date &&
                            moment(driver_promotions?.created_date).format(regionDateAndTime().GENERAL_DATE_FORMAT);
                        driverpromotion = {
                            value: driver_promotions.promotion.id,
                            label: `${driver_promotions.promotion.name} (${driver_promotions.promotion.code})`,
                        };
                    });
                }

                this.intialValues = {
                    first_name: driverDetails.first_name,
                    last_name: driverDetails.last_name,
                    email: driverDetails.email,
                    address: driverDetails.address,
                    address2: driverDetails.address2,
                    city: driverDetails.city,
                    county: driverDetails.county,
                    postal_code: driverDetails.postal_code,
                    billing_address: driverDetails.billing_address,
                    billing_address2: driverDetails.billing_address2,
                    billing_city: driverDetails.billing_city,
                    billing_county: driverDetails.billing_county,
                    billing_postal_code: driverDetails.billing_postal_code,
                    referral_code: driverDetails.referral_code,
                    organization: (driverDetails.organisation && driverDetails.organisation.name) || '',
                    account_type: (driverDetails.account_type_details && driverDetails.account_type_details.name) || '',
                    payment_type: (driverDetails.payment_type_details && driverDetails.payment_type_details.name) || '',
                    driverGroups: [...driverGroup],
                    driver_tags: this.generateOptions(driverDetails.driver_tags),
                    promotion: driverpromotion,
                    currentDriverPromotion: currentDriverPromotion,
                    driverPromotionJoinDate: driverPromotionJoinDate,
                    languagePreference: driverDetails?.language_preference
                        ? driverDetails.language_preference
                        : initialLang,
                };
            }
        }

        this.setState({
            ...this.state,
            driverTagList: this.generateOptions(driverTags),
            driverGroupList: [...userGroupList],
            driverPromotionsList: [...promotionsList],
            address: driverDetails.address,
            billing_address: driverDetails.billing_address_text,
        });
    }
    generateOptions = (tags: any) => {
        const options = [];
        if (tags) {
            tags.forEach((element: any, index: number) => {
                const option = {
                    value: element.name,
                    label: element.name,
                };
                options.push(option);
            });
        }
        return options;
    };

    getDriverTags = async () => {
        let driverTags = [];
        await this.driverService
            .getDriverTags()
            .then(async (res: StandardResponse<any>) => {
                driverTags = res.Data.rows;
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return driverTags;
    };

    getDriverDetails = async (id: number) => {
        let driverDetails;
        await this.driverService
            .getDriverDetail(id)
            .then(async (res: StandardResponse<IUserDetail>) => {
                driverDetails = res.Data;
            })
            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return driverDetails;
    };

    getDriverGroupList = async () => {
        let driverGroupList = [];
        await this.driverGroupService
            .searchDriverGroup({ order: [['name', 'asc']], status: [Common.DriverGroupStatus.ENABLE] })
            .then(async (res: StandardResponse<IDriverGroupList>) => {
                driverGroupList = res.Data.rows;
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return driverGroupList;
    };
    getDriverPromotionList = async () => {
        let promotionsList = [];
        await this.driverPromotionService
            .getDriverPromotionList({ status: ['ENABLE'], for_organisations: false, order: [['name', 'asc']] })
            .then(async (res: StandardResponse<IDriverPromotionList>) => {
                if (res.Data && res.Data.rows) {
                    promotionsList = res.Data.rows.filter((x) => x.active === true);
                }
            })

            .catch((m) => {
                toast.error(m.toString());
            })
            .finally();

        return promotionsList;
    };
    editUser = async (values: IDriverDetailForm, id: number) => {
        const driverGroupIds: Array<any> = [];
        const tagsData: Array<any> = [];
        let promotion_id = 0;
        if (_.isArray(values.driverGroups)) {
            values.driverGroups.forEach((item) => {
                driverGroupIds.push(item.value);
            });
        }
        if (_.isArray(values.driver_tags)) {
            values.driver_tags.forEach((tagdetail) => {
                tagsData.push(tagdetail.name !== undefined ? tagdetail.name : tagdetail.value);
            });
        }
        if (values.promotion) {
            let item = values.promotion;
            promotion_id = parseInt(item.value);
        }
        await this.driverService
            .editDriver(
                {
                    driver_group_ids: driverGroupIds,
                    driver_tags: tagsData,
                    promotion_id: promotion_id,
                    language_preference_id: values.languagePreference.id,
                },
                id,
            )
            .then(async (res: StandardResponse<{ id: number }>) => {
                toast.success(res.Messages);
                this.props.toggleCloseDriversPage();
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            })
            .finally();
    };

    handleSubmit = async (values: IDriverDetailForm) => {
        if (this.state.mode === 'EDIT') {
            await this.editUser(values, this.props.id);
        }
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="title row align-items-content justify-content-between pb-3">
                    <div className="col-auto col-sm text-truncate pr-0">
                        <h1 className="text-truncate">{t('driver.manageDriver')}</h1>
                    </div>
                    <div className="col-auto">
                        <div className="btn-list">
                            <button
                                title={t('driver.button.back')}
                                type="button"
                                className="btn btn-icon pr-0 btn-outline-primary"
                                onClick={() => this.props.toggleCloseDriversPage()}
                            >
                                <img className="icon" src={images.backArrowSVG} alt={t<string>('driver.button.back')} />
                            </button>
                        </div>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={this.intialValues}
                    onSubmit={this.handleSubmit}
                    validationSchema={DriverValidationSchema(t)}
                    render={(props) => {
                        const { handleSubmit, setFieldTouched, setFieldValue, touched, errors, values } = props;
                        return (
                            <form className="form-primary-info" onSubmit={handleSubmit} autoComplete="off">
                                <div className="card-outer pt-3 pl-3 pr-3">
                                    <div className="title row align-items-content justify-content-between pb-3">
                                        <div className="col-auto col-sm text-truncate pr-0">
                                            <h3 className="text-truncate">{t('driver.detail')}</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="first_name"
                                                placeholder={t('driver.placeholder.firstName')}
                                                label={t('driver.label.firstName')}
                                                maxLength={20}
                                                component={ReactstrapLabel}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="last_name"
                                                placeholder={t('driver.placeholder.lastName')}
                                                label={t('driver.label.lastName')}
                                                maxLength={20}
                                                component={ReactstrapLabel}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="email"
                                                placeholder={t('driver.placeholder.email')}
                                                label={t('driver.label.email')}
                                                component={ReactstrapLabel}
                                                maxLength={50}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="organization"
                                                placeholder={t('driver.placeholder.organization')}
                                                label={t('driver.label.organization')}
                                                component={ReactstrapLabel}
                                                maxLength={50}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="account_type"
                                                placeholder={t('driver.placeholder.account_type')}
                                                label={t('driver.label.account_type')}
                                                component={ReactstrapLabel}
                                                maxLength={50}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="payment_type"
                                                placeholder={t('driver.placeholder.payment_type')}
                                                label={t('driver.label.payment_type')}
                                                component={ReactstrapLabel}
                                                maxLength={50}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="referral_code"
                                                placeholder={t('driver.placeholder.referral_code')}
                                                label={t('driver.label.referral_code')}
                                                component={ReactstrapLabel}
                                                maxLength={50}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="currentDriverPromotion"
                                                placeholder={t('driver.placeholder.currentDriverPromotion')}
                                                label={t('driver.label.currentDriverPromotion')}
                                                maxLength={20}
                                                component={ReactstrapLabel}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <Field
                                                name="driverPromotionJoinDate"
                                                placeholder={t('driver.placeholder.driverPromotionJoinDate')}
                                                label={t('driver.label.driverPromotionJoinDate')}
                                                maxLength={20}
                                                component={ReactstrapLabel}
                                                disabled={this.state.mode === 'EDIT'}
                                            />
                                        </div>
                                        {this.state.mode === 'EDIT' && (
                                            <div className="col-md-6 col-lg-4">
                                                <SelectBox
                                                    label={t('driver.label.languagePreference')}
                                                    placeholder={t('driver.placeholder.languagePreference')}
                                                    name="languagePreference"
                                                    className={
                                                        Boolean(
                                                            touched['languagePreference'] &&
                                                                errors['languagePreference'],
                                                        )
                                                            ? 'form-group is-invalid'
                                                            : 'form-group'
                                                    }
                                                    value={values.languagePreference}
                                                    onChange={(value) => setFieldValue('languagePreference', value)}
                                                    onBlur={() => setFieldTouched('languagePreference', true)}
                                                    options={supportedLanguages}
                                                    getOptionLabel={(opt) => opt.name}
                                                    getOptionValue={(opt) => opt.code}
                                                    touched={touched.languagePreference}
                                                    errors={errors.languagePreference}
                                                    isClearable={true}
                                                    isInvalid={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="title row align-items-content justify-content-between pb-3">
                                        <div className="col-auto col-sm text-truncate pr-0">
                                            <h3 className="text-truncate">{t('driver.address_detail')}</h3>
                                        </div>
                                    </div>
                                    <span style={{ whiteSpace: 'pre-line' }}>{this.state.address}</span>
                                    <div className="title row align-items-content justify-content-between pb-3 pt-4">
                                        <div className="col-auto col-sm text-truncate pr-0">
                                            <h3 className="text-truncate">{t('driver.billing_address_detail')}</h3>
                                        </div>
                                    </div>
                                    <span style={{ whiteSpace: 'pre-line' }}>{this.state.billing_address}</span>
                                    <div className="row pt-4">
                                        <div className="form-group col-md-6 col-lg-4">
                                            <SelectBox
                                                name="driverGroups"
                                                label={t('driver.label.driverGroups')}
                                                value={values.driverGroups}
                                                options={this.state.driverGroupList}
                                                isMulti={true}
                                                isInvalid={true}
                                                onChange={(value) => {
                                                    setFieldValue('driverGroups', value !== null ? value : []);
                                                }}
                                                onBlur={() => setFieldTouched('driverGroups', true)}
                                                placeholder={t('driver.placeholder.driverGroup')}
                                                touched={touched.driverGroups}
                                                errors={errors.driverGroups}
                                            />
                                        </div>
                                        <div className="form-group col-md-6 col-lg-4">
                                            <CreatableSelectBox
                                                name="driver_tags"
                                                label={t('driver.label.driver_tags')}
                                                value={values.driver_tags}
                                                options={this.state.driverTagList}
                                                isMulti={true}
                                                isInvalid={false}
                                                onChange={(value) => {
                                                    setFieldValue('driver_tags', value !== null ? value : []);
                                                }}
                                                onBlur={() => setFieldTouched('driver_tags', true)}
                                                placeholder={t('driver.placeholder.driver_tags')}
                                                touched={touched.driver_tags}
                                                errors={errors.driver_tags}
                                                inputProps={{ maxLength: 50 }}
                                            />
                                        </div>
                                        <div className="form-group col-md-6 col-lg-4">
                                            <SelectBox
                                                name="promotion"
                                                label={t('driver.label.promotion')}
                                                value={values.promotion}
                                                options={this.state.driverPromotionsList}
                                                isMulti={false}
                                                isInvalid={true}
                                                onChange={(value) => {
                                                    setFieldValue('promotion', value);
                                                }}
                                                onBlur={() => setFieldTouched('promotion', true)}
                                                placeholder={t('driver.placeholder.promotion')}
                                                touched={touched.promotion}
                                                errors={errors.promotion}
                                                isClearable={true}
                                            />
                                            <label className="mt-2"> {t('driver.note')}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-auto">
                                            <button
                                                type="submit"
                                                className="btn btn-primary mr-2"
                                                title={t<string>('driver.button.save')}
                                            >
                                                <span>{t('driver.button.save')}</span>
                                            </button>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => this.props.toggleCloseDriversPage()}
                                                title={t<string>('driver.button.cancel')}
                                            >
                                                <span>{t('driver.button.cancel')}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                ></Formik>
            </>
        );
    }
}

export default DriversInsert;
